var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.415,
    height: 52.524,
    viewBox: "0 0 52.415 52.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecf0fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M834.855,752.852a16.458,16.458,0,0,0-1.529-3.822l1.31-3.057L830.05,741.5l-3.058,1.311a14.727,14.727,0,0,0-3.822-1.529l-1.092-3.167h-6.443l-1.2,3.167a16.428,16.428,0,0,0-3.822,1.529l-3.058-1.311-4.477,4.477,1.31,3.057a14.73,14.73,0,0,0-1.529,3.822l-3.167,1.2V760.5l3.167,1.2a16.438,16.438,0,0,0,1.529,3.822l-1.31,3.057,4.586,4.477,3.058-1.31a14.739,14.739,0,0,0,3.822,1.529l1.2,3.167h6.334l1.2-3.167a16.466,16.466,0,0,0,3.822-1.529l3.058,1.31,4.586-4.477-1.31-3.057a14.746,14.746,0,0,0,1.529-3.822l3.167-1.2v-6.443ZM818.8,765.082a7.862,7.862,0,1,1,7.862-7.862A7.83,7.83,0,0,1,818.8,765.082Z",
    transform: "translate(-799.693 -738.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M878.153,853.114a5.288,5.288,0,0,0,0-1.856l1.092-1.092-1.092-2.73h-1.529a14.919,14.919,0,0,0-1.31-1.311V844.6l-2.73-1.092-1.092,1.092a5.309,5.309,0,0,0-1.856,0l-1.092-1.092-2.73,1.092v1.529a14.929,14.929,0,0,0-1.31,1.311h-1.529l-1.092,2.73,1.092,1.092a5.288,5.288,0,0,0,0,1.856l-1.092,1.092,1.092,2.73H864.5a14.786,14.786,0,0,0,1.31,1.31v1.529l2.73,1.092,1.092-1.092a5.286,5.286,0,0,0,1.856,0l1.092,1.092,2.73-1.092v-1.529a14.893,14.893,0,0,0,1.31-1.31h1.529l1.092-2.73Zm-8.736,2.293A3.528,3.528,0,1,1,874,853.442,3.492,3.492,0,0,1,869.417,855.407Z",
    transform: "translate(-841.135 -808.343)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M921.031,810.236a5.3,5.3,0,0,0,0-1.856l1.092-1.092-1.092-2.73H919.5a14.84,14.84,0,0,0-1.31-1.31v-1.529l-2.73-1.092-1.092,1.092a5.306,5.306,0,0,0-1.856,0l-1.092-1.092-2.73,1.092v1.529a14.871,14.871,0,0,0-1.31,1.31h-1.529l-1.092,2.73,1.092,1.092a5.291,5.291,0,0,0,0,1.856l-1.092,1.092,1.092,2.73h1.529a14.845,14.845,0,0,0,1.31,1.31V816.9l2.73,1.092,1.092-1.092a5.306,5.306,0,0,0,1.856,0l1.092,1.092,2.73-1.092v-1.529a14.784,14.784,0,0,0,1.31-1.31h1.529l1.092-2.73Zm-8.845,2.4a3.528,3.528,0,1,1,4.586-1.965A3.419,3.419,0,0,1,912.186,812.639Z",
    transform: "translate(-869.708 -779.77)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/Gear.d8cec4bce96623276a9f0b190b244d20.svg";
export { ForwardRef as ReactComponent };